/**
 * Scheduled Events card on a quote or job page: a tapped visit opens the same
 * event modal the calendar and the Dispatch board open (details, reschedule,
 * crew, delete), so a visit is edited in one place wherever it is found.
 *
 * Lives on the card's list (components/detail/scheduled_events_card.html); each
 * visit row carries `data-event`, the calendar feed's serialisation of it. The
 * banner's "Scheduled <day>" badge (components/detail/_entity_banner.html) is
 * its own instance, carrying the next visit the same way. The
 * modal (calendar/_event_modal.html) is on the page through the entity's
 * *_detail_modals section.
 *
 * The modal saves through the calendar JSON API, which has nothing to patch on
 * this page, so a change re-renders it through the page check.
 */
import { Controller } from '@hotwired/stimulus';

import { openEventDetail, visitFromData } from '../../calendar/event-detail.js';

export default class extends Controller {
    open(event) {
        openEventDetail(visitFromData(event.currentTarget.dataset.event), () => {
            window.chippiePageCheck.refresh();
        });
    }
}
